export function TableHeader({ columns, variant = "asset", testId }) {
  return (
    <div className={`table-header ${variant}`} data-testid={testId}>
      {columns.map((column) => <span key={column}>{column}</span>)}
    </div>
  );
}